const abilities = {
  lucie: {
    royale: [
      {
        type: "F",
        description:
          "Throw a vial of mixed chemicals to target location, dealing impact damage and snaring enemies. Covers the ground in a crippling goo that deals damage over a short duration and applies Poison.",
        name: "Crippling Goo"
      },
      {
        type: "R",
        description:
          "Throw a brew to target location that heals self or ally. The brew can be enhanced by Drag and Dropping a potion onto this ability slot, consuming the potion to grant Alchemist's Brew an additional effect.",
        name: "Alchemist's Brew"
      },
      {
        type: "E",
        description: "Throw a flask dealing damage and inflicting panic",
        name: "Panic Flask"
      },
      {
        type: "Q",
        description:
          "Throw a reagent to target location, knocking nearby enemies back and inflicting Snare. consumes Poison from enemies to drain health per stack.",
        name: "Catalyst"
      },
      {
        type: "Space",
        description: "Roll forward and avoid incoming attacks (2 charges)",
        name: "Roll"
      },
      {
        type: "M2",
        description:
          "Fire a series of 3 toxic bolts. Each bolt deals damage and inflicts Poison.",
        name: "Rapid Fire"
      },
      {
        type: "M1",
        description: "Projectile attack that deals damage and inflicts Poison",
        name: "Poison Bolt"
      }
    ]
  },

  poloma: {
    royale: [
      {
        type: "F",
        description:
          "Summon an ancestral spirit at target location and become immaterial briefly. Deals damage and inflicts Fading Snare to enemies and heals allies. After 2s, the spirit departs and summons a Ghost Wolf to rush each nearby enemy.",
        name: "Ancestral Spirit"
      },
      {
        type: "R",
        description:
          "Go into the spirit realm, increasing movement speed and making you immaterial but unable to use abilities.",
        name: "Other Side"
      },
      {
        type: "E",
        description:
          "Project a spirit that deals damage to enemies or heals allies and yourself. You and the other player swap location on impact, Can be recast to teleport to the spirit if no player is hit.",
        name: "Soul Transfer"
      },
      {
        type: "Q",
        description:
          "Opens a rift that interrupts the next ability cast by nearby enemies. Inflicts Panic when an ability is interrupted. The panicked target runs at increased movement speed.",
        name: "Spirit Rift"
      },
      {
        type: "Space",
        description:
          "Summon a Spirit Guide that heals an ally for health or deals damage and knocks an enemy back. Travels through walls and can be recast to teleport to the spirit.",
        name: "Spirit Guide"
      },
      {
        type: "M2",
        description:
          "Summon a Ghost Wolf that strikes up to 3 targets. Deals damage and inflicts Soul Bind on each hit.",
        name: "Ghost Wolf"
      },
      {
        type: "M1",
        description:
          "Fire a Soul Bolt that deals damage and inflicts Soul Bind on enemy hit. Heals health and applies Spirit Link on ally hit.",
        name: "Soul Bolt"
      }
    ]
  },
  dragonlord: {
    arena: [
      {
        type: "F",
        description:
          "Summon storm dragons to orbit you dealing damage and inflicting Snare on enemies hit. Recast to fire all dragons in the same direction.",
        name: "Dragon Storm"
      },
      {
        type: "R",
        description:
          "Create a field of empowering magic that heals nearby allies for health. While inside the field you move faster and can move while casting Shock Blast.",
        name: "Dominion"
      },
      {
        type: "E",
        description:
          "Cause lightning to strike down at target location. The lightning bolt deals damage and inflicts Root. A delayed blast deals additional damage in a larger area and inflicts Silence.",
        name: "Dragon Roar"
      },
      {
        type: "Q",
        description:
          "Block projectiles and melee attacks from in front of you by creating a whirling wind that knocks away enemies. Any projectile that is blocked extends the duration of the whirl.",
        name: "Dismissal"
      },
      {
        type: "Space",
        description:
          "Travel to target location move faster for some time while hovering. During this time you may cast two Lightning Bolts that deal damage.",
        name: "Ascension"
      },
      {
        type: "M2",
        description:
          "Produce a violent storm that deals damage and inflicts Storm Struck.",
        name: "Storm Bolt"
      },
      {
        type: "M1",
        description:
          "Shoot an accelerating projectile that explodes dealing damage.",
        name: "Shock Blast"
      },

      {
        type: "EX E",
        description:
          "Summon a thundercloud that strikes twice dealing damage. The second hit inflicts Stun.",

        name: "Soaring Thunder"
      },
      {
        type: "EX Q",
        description:
          "Send forth a strong gust of wind that knocks enemies back and creates a wind trail that redirects projectiles.",
        name: "Jet Stream"
      }
    ],
    royale: [
      {
        type: "F",
        description:
          "Summon storm dragons to orbit you dealing damage and inflicting Snare on enemies hit. Recast to fire all dragons in the same direction.",
        name: "Dragon Storm"
      },
      {
        type: "R",
        description:
          "Create a field of empowering magic that heals nearby allies for health. While inside the field you move faster and can move while casting Shock Blast.",
        name: "Dominion"
      },
      {
        type: "E",
        description:
          "Cause lightning to strike down at target location. The lightning bolt deals damage and inflicts Root. A delayed blast deals additional damage in a larger area and inflicts Silence.",
        name: "Dragon Roar"
      },
      {
        type: "Q",
        description:
          "Send forth a strong gust of wind that knocks enemies back and creates a wind trail that redirects projectiles. Enemies and allies in the trail are pulled along.",
        name: "Jet Stream"
      },
      {
        type: "Space",
        description:
          "Travel to target location move faster for some time while hovering. During this time you may cast two Lightning Bolts that deal damage.",
        name: "Ascension"
      },
      {
        type: "M2",
        description:
          "Produce a violent storm that deals damage and inflicts Storm Struck.",
        name: "Storm Bolt"
      },
      {
        type: "M1",
        description:
          "Shoot an accelerating projectile that explodes dealing damage.",
        name: "Shock Blast"
      }
    ]
  }
};

module.exports = {
  abilities
};
